export const SPORTS = [
  "Baseball",
  "Basketball",
  "Football",
  "Hockey",
  "Soccer",
  "Golf",
  "Tennis",
  "Boxing/MMA",
  "Wrestling",
  "Racing",
  "Pokemon",
  "Other",
];
